// extracted by mini-css-extract-plugin
export var actionList = "style-module--actionList--b9f82";
export var banner = "style-module--banner--be928";
export var buttonText = "style-module--buttonText--45818";
export var close = "style-module--close--0b59d";
export var consentBannerOverlay = "style-module--consentBannerOverlay--51197";
export var consentGroup = "style-module--consentGroup--76b8a";
export var content = "style-module--content--b32d5";
export var groupContent = "style-module--groupContent--ac660";
export var groupHeader = "style-module--groupHeader--8ffcd";
export var header = "style-module--header--db6b2";
export var minimal = "style-module--minimal--485fd";
export var secondary = "style-module--secondary--c171a";